import {DOCUMENT_ADDED_TO_UPLOAD, DOCUMENT_UPLOADED} from '../actions/types';

const INITIAL_STATE = [];

export const uploadingDocumentsArray = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DOCUMENT_ADDED_TO_UPLOAD:
            state.push(action.documentId);
            return state;
        case DOCUMENT_UPLOADED:
            state = state.filter((el) => el !== action.documentId);
            return state;
    }
    return state;
};
